import { useTranslation } from 'react-i18next';
import React, { memo } from 'react';
import cx from 'clsx';

import { IconRcFeedInvisible } from '@/assets/stream';
import type { FeedArticle } from '@/views/Stream';

import style from './index.module.scss';

type DowngradeCardProps = {
  ref?: React.Ref<HTMLDivElement>;
  className?: string;
  handleContentClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
};

export const DowngradeCard = memo(({ ref, className, handleContentClick }: DowngradeCardProps) => {
  const { t } = useTranslation();

  return (
    <div className={cx(style.articleMain, className)} ref={ref}>
      <div className={style.articleContent} onClick={handleContentClick}>
        <div className={style.inVisible}>
          <IconRcFeedInvisible className={style.invisbileIcon} />
          <span className={style.invisbileTitle}>{t('DowngradeCard.q1xtng')}</span>
          {t('DowngradeCard.1ksoiwc')}
        </div>
      </div>
    </div>
  );
});

type InvisibleCardProps = {
  ref?: React.Ref<HTMLDivElement>;
  className?: string;
  article: FeedArticle;
  handleContentClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
};

export const InvisibleCard = memo(
  ({ ref, className, handleContentClick, article }: InvisibleCardProps) => {
    const { t } = useTranslation();

    return (
      <div className={cx(style.articleMain, className)} ref={ref}>
        <div className={style.articleContent} onClick={handleContentClick}>
          <div className={style.inVisible}>
            <IconRcFeedInvisible className={style.invisbileIcon} />
            <span className={style.invisbileTitle}>{t('DowngradeCard.qgunf8')}</span>
            {article.not_visible_reason}
          </div>
        </div>
      </div>
    );
  },
);
